/** 查新用户首次引导 service 的页面上下文。 */
export interface NoveltySearchOnboardingStartOptions {
    /** 获取输入框的当前值。 */
    getInputValue: () => string;
    /** 获取是否存在外部带入的输入；为 true 时跳过首页输入及提交引导。 */
    getHasPrefilledInput: () => boolean;
    /** 获取 URL 自动运行状态。 */
    getIsAutoRunning: () => boolean;
}

/** 查新用户首次引导 service。 */
export interface NoveltySearchOnboardingService {
    /**
     * 按当前输入、自动运行和公共账号资格尝试启动引导。
     * @param options 当前查新页面状态。
     */
    start(options: NoveltySearchOnboardingStartOptions): Promise<boolean>;
    /** 通知用户已聚焦查新输入框。 */
    notifyInputFocused(): void;
    /** 通知用户已通过查新示例填充输入框。 */
    notifyExampleSelected(): void;
    /** 通知用户在输入框中进行了原生输入。 */
    notifyManualInput(value: string): void;
    /** 消费当前提交提示的引导归因标识。 */
    consumeSubmitGuide(): boolean;
    /** 销毁当前 Driver 实例并终止尚未完成的启动流程。 */
    destroy(): void;
}

/** 查新用户首次引导 service 的容器标识。 */
export const NoveltySearchOnboardingService = Symbol('NoveltySearchOnboardingService');
